import getScroll from "shared/util/getScroll";

import {
	LEADERBOARD_ID,
	POPOVER_WIDTH,
	POPOVER_HEIGHT,
	POPOVER_TO_WINDOW_GUTTER,
	ARROW_GUTTER,
} from "shared/components/ProfileQuickview/util/constants";


/**
 * Create positioning data for the popover based on a given target element.
 * @param {DomNode} target - the element to position
 * @return {Object} res - a dictionary of positioning information
 * @return {number} res.top - the top position of the popover
 * @return {number} res.left - the left position of the popover
 * @return {number} res.arrowMarginLeft - the left margin of the popover's arrow
 * @return {bool} res.isFlipped - true if the popover is too close to the top
 *   of the screen and should show up under the target
 */
export const getPopoverPosition = (target) => {
	const windowWidth = window.innerWidth;
	const scrollTop = getScroll();
	const targetBox = target.getBoundingClientRect();
	const leaderboard = document.getElementById(LEADERBOARD_ID);
	let targetTopOffset = targetBox.top + scrollTop;

	let isFlipped = false;
	let top = 0;
	let left = 0;
	let arrowMarginLeft = 0;

	// compensate for the height of the leaderboard for non-alist users
	if (leaderboard) {
		targetTopOffset -= leaderboard.getBoundingClientRect().height;
	}

	// Top and too-close-to-the-top handling
	top = targetTopOffset - POPOVER_HEIGHT - 18;

	if (top < POPOVER_TO_WINDOW_GUTTER + scrollTop) {
		isFlipped = true;
		top = targetTopOffset + targetBox.height + 18;
	}

	// left / right handling
	left = targetBox.left - ARROW_GUTTER + targetBox.width / 2;
	arrowMarginLeft = -(POPOVER_WIDTH / 2) + ARROW_GUTTER;

	if (left + POPOVER_WIDTH > windowWidth - POPOVER_TO_WINDOW_GUTTER) {
		left = targetBox.left - POPOVER_WIDTH + ARROW_GUTTER + targetBox.width / 2;
		arrowMarginLeft *= -1;
	}

	return {
		top,
		left,
		arrowMarginLeft,
		isFlipped,
	};
};



// WEBPACK FOOTER //
// ./src/shared/components/ProfileQuickview/util/helpers.js